import React from 'react';
import { useMeters } from '../../../../../../../hooks/requests/use-meters';
import './ProductSourceSelect.css';
import { Autocomplete } from '@mui/material';
import type { AutocompleteProps } from '@mui/material/Autocomplete/Autocomplete';
import type { ObjectId } from '@weft/types';
import { extract } from '@weft/utils';
import { VayuTextField } from '../../../../../../../components/design/vayu-theme-components/VayuTextField';

type ProductSourceSelectProps = {
  error?: boolean
  helperText?: string;
} & Omit<AutocompleteProps<ObjectId, false, false, false>, 'options' | 'renderInput'>;

export const ProductSourceSelect: React.FC<ProductSourceSelectProps> = (({ error, helperText, ...props }) => {
  const { data: { meters } } = useMeters();

  return (
    <Autocomplete
      fullWidth
      autoHighlight
      size="small"
      getOptionLabel={(option) => meters.find(({ id }) => id === option)?.name || ''}
      {...props}
      options={extract(meters, 'id')}
      renderInput={(params) => (
        <VayuTextField
          {...params}
          label="Select product source"
          placeholder="Product source"
          focused
          helperText={error && (
            <div className="text-input-error flex items-center gap-x-2 pt-0.5 text-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M7.90669 14.5556C4.01025 14.5556 0.851562 11.3968 0.851562 7.50044C0.851562 3.604 4.01025 0.445312 7.90669
                       0.445312C11.8031 0.445312 14.9618 3.604 14.9618 7.50044C14.9618 11.3968 11.8031 14.5556 7.90669 14.5556ZM7.20118
                        9.61698V11.028H8.61221V9.61698H7.20118ZM7.20118 3.97288V8.20596H8.61221V3.97288H7.20118Z"
                  fill="#FF154D"
                />
              </svg>
              <span>{helperText}</span>
            </div>
          )}
        />
      )}
    />
  );
});